import { render, staticRenderFns } from "./SalaryEffectDelete.vue?vue&type=template&id=6caad0ef&scoped=true&"
import script from "./SalaryEffectDelete.vue?vue&type=script&lang=js&"
export * from "./SalaryEffectDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caad0ef",
  null
  
)

export default component.exports